import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from './helpers/consts.helper';
import { CustomerStorageService } from './modules/account/services/customer-storage.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})

export class AppComponent implements OnInit {

  iaChatbotUrl: any;
  brand?: string;

  constructor(
      private store: Store<any>,
      private customerStorageService: CustomerStorageService,
  ) {}

  ngOnInit() {
    this.iaChatbotUrl = null;
    this.brand = environment.data.brand;
    this.store.pipe(select(ConstsHelper.REDUCER_DISPLAY_IA_CHATBOT)).subscribe((result: { iaChatbotUrl: string|null }) => {
      if (this.customerStorageService.getCustomer() && !window.location.href.includes('finaliser/souscription')) {
        this.iaChatbotUrl = result.iaChatbotUrl;
      } else {
        this.iaChatbotUrl = null;
      }
    });

    setInterval(() => {
      if (document.getElementsByClassName('mat-mdc-form-field-icon-suffix')) {
        const calendarIcons = document.getElementsByClassName('mat-mdc-form-field-icon-suffix');
        const  calendarIcon = calendarIcons.item(0).getBoundingClientRect();
        const overlays = document.querySelectorAll('[id*="cdk-overlay-"]');
        const calendarItem = overlays.item(0) as HTMLElement;
        if (calendarItem) {
          calendarItem.style.top = (calendarIcon.top - 340)+'px';
          calendarItem.style.left = (calendarIcon.left - 280)+'px';
          calendarItem.style.display = 'block';
        }
      }
    }, 10);
  }
}
